import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const EDR: React.FC = () => {
  const sections = [
    {
      title: 'Endpoint Detection and Response (EDR)',
      content: 'Our EDR solutions provide advanced threat detection, investigation, and response capabilities for endpoints across your organization. We deploy and manage industry-leading EDR platforms that continuously monitor endpoint activities, detect sophisticated threats, and enable rapid incident response.',
      benefits: [
        'Real-time endpoint monitoring and threat detection',
        'Advanced behavioral analysis and machine learning',
        'Automated threat hunting and investigation',
        'Incident response and remediation capabilities',
        '24/7 security operations center monitoring'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Endpoint Detection & Response"
      subtitle="Advanced EDR solutions for comprehensive endpoint security monitoring, threat detection, and rapid incident response."
      sections={sections}
    />
  );
};

export default EDR;

